export default __webpack_public_path__ + "static/media/deliveryonly_deactive.96ec6858.svg";